define("shared/components/shared/post/secondary/caption-writer/disclaimer", ["exports", "@ember/component", "@ember/template-factory", "@ember/object", "@glimmer/component", "ember-concurrency-ts", "tracked-built-ins"], function (_exports, _component, _templateFactory, _object, _component2, _emberConcurrencyTs, _trackedBuiltIns) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _class, _descriptor;

  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/object",0,"@glimmer/component",0,"ember-concurrency-ts",0,"tracked-built-ins"eaimeta@70e063a35619d71f

  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  <Shared::Modal @close={{@closeModal}} @focusTrap={{true}} data-test-id="caption-writer-disclaimer-modal" as |modal|>
    <modal.card @portrait={{true}} class="u--p__b__0 qa--caption_writer_disclaimer_modal">
      <modal.card-header @title={{t "caption_writer.disclaimer_modal.title"}} />
  
      <modal.card-body class="u--p__t__0">
        <section>
          <p class="">
            {{t "caption_writer.disclaimer_modal.instructions" htmlSafe=true}}
          </p>
        </section>
        <section>
          <p>
            {{t "caption_writer.disclaimer_modal.disclaimer" htmlSafe=true}}
          </p>
          <Shared::Link
            @class="u--text--hl"
            @href="https://help.later.com/hc/articles/12252569781015"
            @text={{t "shared_phrases.learn_more"}}
            @type="unstyled"
          />
        </section>
        <hr class="u--m__tb__lg" />
        <form class="o--form__checkbox" data-test-id="caption-writer-disclaimer" onsubmit={{this.submitDisclaimer}}>
          <label class="u--m__b__lg">
            <Input
              @checked={{this.acceptedDisclaimer}}
              @type="checkbox"
              data-test-id="caption-writer-disclaimer-input"
              id="acceptedDisclaimer"
            />
            {{t "caption_writer.disclaimer_modal.consent"}}
          </label>
          <Shared::Ui::Button
            @additional="block"
            @class={{concat-classes
              "qa--aiCaptions_acceptDisclaimersBtn"
              (if this.isButtonDisabled "qa--aiCaptions_acceptDisclaimersBtn_disabled")
            }}
            @isDisabled={{this.isButtonDisabled}}
            @text={{t "shared_phrases.get_started"}}
            data-test-id="caption-writer-disclaimer-submit"
            type="submit"
          />
        </form>
      </modal.card-body>
    </modal.card>
  </Shared::Modal>
  */
  {
    "id": "21OBpQJI",
    "block": "[[[8,[39,0],[[24,\"data-test-id\",\"caption-writer-disclaimer-modal\"]],[[\"@close\",\"@focusTrap\"],[[30,1],true]],[[\"default\"],[[[[1,\"\\n  \"],[8,[30,2,[\"card\"]],[[24,0,\"u--p__b__0 qa--caption_writer_disclaimer_modal\"]],[[\"@portrait\"],[true]],[[\"default\"],[[[[1,\"\\n    \"],[8,[30,2,[\"card-header\"]],null,[[\"@title\"],[[28,[37,1],[\"caption_writer.disclaimer_modal.title\"],null]]],null],[1,\"\\n\\n    \"],[8,[30,2,[\"card-body\"]],[[24,0,\"u--p__t__0\"]],null,[[\"default\"],[[[[1,\"\\n      \"],[10,\"section\"],[12],[1,\"\\n        \"],[10,2],[14,0,\"\"],[12],[1,\"\\n          \"],[1,[28,[35,1],[\"caption_writer.disclaimer_modal.instructions\"],[[\"htmlSafe\"],[true]]]],[1,\"\\n        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n      \"],[10,\"section\"],[12],[1,\"\\n        \"],[10,2],[12],[1,\"\\n          \"],[1,[28,[35,1],[\"caption_writer.disclaimer_modal.disclaimer\"],[[\"htmlSafe\"],[true]]]],[1,\"\\n        \"],[13],[1,\"\\n        \"],[8,[39,2],null,[[\"@class\",\"@href\",\"@text\",\"@type\"],[\"u--text--hl\",\"https://help.later.com/hc/articles/12252569781015\",[28,[37,1],[\"shared_phrases.learn_more\"],null],\"unstyled\"]],null],[1,\"\\n      \"],[13],[1,\"\\n      \"],[10,\"hr\"],[14,0,\"u--m__tb__lg\"],[12],[13],[1,\"\\n      \"],[10,\"form\"],[14,0,\"o--form__checkbox\"],[14,\"data-test-id\",\"caption-writer-disclaimer\"],[15,\"onsubmit\",[30,0,[\"submitDisclaimer\"]]],[12],[1,\"\\n        \"],[10,\"label\"],[14,0,\"u--m__b__lg\"],[12],[1,\"\\n          \"],[8,[39,3],[[24,\"data-test-id\",\"caption-writer-disclaimer-input\"],[24,1,\"acceptedDisclaimer\"]],[[\"@checked\",\"@type\"],[[30,0,[\"acceptedDisclaimer\"]],\"checkbox\"]],null],[1,\"\\n          \"],[1,[28,[35,1],[\"caption_writer.disclaimer_modal.consent\"],null]],[1,\"\\n        \"],[13],[1,\"\\n        \"],[8,[39,4],[[24,\"data-test-id\",\"caption-writer-disclaimer-submit\"],[24,4,\"submit\"]],[[\"@additional\",\"@class\",\"@isDisabled\",\"@text\"],[\"block\",[28,[37,5],[\"qa--aiCaptions_acceptDisclaimersBtn\",[52,[30,0,[\"isButtonDisabled\"]],\"qa--aiCaptions_acceptDisclaimersBtn_disabled\"]],null],[30,0,[\"isButtonDisabled\"]],[28,[37,1],[\"shared_phrases.get_started\"],null]]],null],[1,\"\\n      \"],[13],[1,\"\\n    \"]],[]]]]],[1,\"\\n  \"]],[]]]]],[1,\"\\n\"]],[2]]]]]],[\"@closeModal\",\"modal\"],false,[\"shared/modal\",\"t\",\"shared/link\",\"input\",\"shared/ui/button\",\"concat-classes\",\"if\"]]",
    "moduleName": "shared/components/shared/post/secondary/caption-writer/disclaimer.hbs",
    "isStrictMode": false
  });

  let DisclaimerComponent = (_class = class DisclaimerComponent extends _component2.default {
    constructor() {
      super(...arguments);

      _initializerDefineProperty(this, "acceptedDisclaimer", _descriptor, this);
    }

    get isButtonDisabled() {
      return !this.acceptedDisclaimer;
    }

    submitDisclaimer(event) {
      event.preventDefault();

      if (this.acceptedDisclaimer) {
        (0, _emberConcurrencyTs.taskFor)(this.args.submitDisclaimer).perform();
      }
    }

  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "acceptedDisclaimer", [_trackedBuiltIns.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _applyDecoratedDescriptor(_class.prototype, "submitDisclaimer", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "submitDisclaimer"), _class.prototype)), _class);
  _exports.default = DisclaimerComponent;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, DisclaimerComponent);
});